export default "__VITE_ASSET__dcb8821f__"